// Section Shopify Shopify.theme editor events
if(Shopify.designMode) {
  $(document)
  .on('shopify:section:reorder', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if (Shopify.theme.jsHeader.enable_overlay == true) {
      Shopify.theme.jsHeader.unload();
      Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
    }

  });

  $(document)
  .on('shopify:section:load', function(e){

    // Shopify section as jQuery object
    var $section = $(e.target);

    // Vanilla js selection of Shopify section
    var section = document.getElementById('shopify-section-' + e.detail.sectionId);

    // Blocks within section
    var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

    var sectionObjectUrl = $section.find('[data-theme-editor-load-script]').attr('src');

    // Check classes on schema and look for js (eg. jsMap)
    for (var i = 0; i < section.classList.length; i++) {
      if (section.classList[i].substring(0, 2) === "js"){
        var triggerClass = section.classList[i];

        // Check to see if section script exists
        if (typeof Shopify.theme[triggerClass] == 'undefined') {
          // make AJAX call to load script
          Shopify.theme.loadScript(triggerClass, sectionObjectUrl, function () {
            Shopify.theme[triggerClass].init($(section));
          });
        } else {
          if (Shopify.theme[triggerClass]) {
            // console.log('Section: ' + triggerClass + ' has been loaded.')
            Shopify.theme[triggerClass].init($(section));
          } else {
            // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
          }
        }
      }
    }

    // Check classes on block element and look for js (eg. jsMap)
    if ($jsSectionBlocks.length > 0) {
      var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
        for (var i = 0; i < this.classList.length; i++) {
          if (this.classList[i].substring(0, 2) === "js") {
            var triggerClass = this.classList[i];
            var $block = $('.'+ triggerClass)
            var blockUrl = $block.find('[data-theme-editor-load-script]').attr('src');

            // Check to see if section script exists
            if (typeof Shopify.theme[triggerClass] == 'undefined') {
              // make AJAX call to load script
              Shopify.theme.loadScript(triggerClass, blockUrl, function () {
                Shopify.theme[triggerClass].init($block);
              });
            } else {
              if (Shopify.theme[triggerClass]) {
                // console.log('Block: ' + triggerClass + ' has been loaded.')
                Shopify.theme[triggerClass].init($(this));
              } else {
                // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
              }
            }

          }
        }
      });
    }

    // Load video feature
    Shopify.theme.video.init();

    // Scrolling animations
    Shopify.theme.animation.init();

    // Initialize reviews
    Shopify.theme.productReviews.init();

    // Object Fit Images
    Shopify.theme.objectFitImages.init();

    // Infinite scrolling
    Shopify.theme.infiniteScroll.init();

    // Disclosure menus
    Shopify.theme.disclosure.enable();

  });


  $(document)
  .on('shopify:section:unload', function(e){

    // Shopify section as jQuery object
    var $section = $(e.target);

    // Vanilla js selection of Shopify section
    var section = document.getElementById('shopify-section-' + e.detail.sectionId);

    // Blocks within section
    var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

    // Check classes on schema and look for js (eg. jsMap)
    for (var i = 0; i < section.classList.length; i++) {
      if (section.classList[i].substring(0, 2) === "js"){
        var triggerClass = section.classList[i];
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' is unloaded.')
          Shopify.theme[triggerClass].unload($(section));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
        }
      }
    }

    // Check classes on block element and look for js (eg. jsMap)
    if ($jsSectionBlocks.length > 0) {
      var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
        for (var i = 0; i < this.classList.length; i++) {
          if (this.classList[i].substring(0, 2) === "js") {
            var triggerClass = this.classList[i];
            if (Shopify.theme[triggerClass]) {
              // console.log('Block: ' + triggerClass + ' is unloaded.')
              Shopify.theme[triggerClass].unload($(this));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
            }

          }
        }
      });
    }

    // Scrolling animations
    Shopify.theme.animation.unload($section);

    // QuantityBox
    Shopify.theme.quantityBox.unload($section);

    // Infinite scrolling
    Shopify.theme.infiniteScroll.unload($section);

    // Disclosure menus
    Shopify.theme.disclosure.enable();

  });

  $(document)
  .on('shopify:section:select', function(e){

    // Shopify section as jQuery object
    var $section = $(e.target);

    // Vanilla js selection of Shopify section
    var section = document.getElementById('shopify-section-' + e.detail.sectionId);

    // Force show state when section is selected in theme editor
    for (var i = 0; i < section.classList.length; i++) {
      if (section.classList[i].substring(0, 2) === "js") {
        var triggerClass = section.classList[i];
        if (Shopify.theme[triggerClass].showThemeEditorState) {
          Shopify.theme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
        }
      }
    }

    // Predictive search
    if (Shopify.theme_settings.enable_autocomplete == true) {
      Shopify.theme.predictiveSearch.init();
    }

    if($('.tabs').length > 0) {
      Shopify.theme.tabs.enableTabs();
    }

    if ($('.newsletter-form__wrapper .contact-form').length > 0) {
      Shopify.theme.newsletterAjaxForm.init();
    }

    if(isScreenSizeLarge() && Shopify.theme.jsHeader.enable_overlay == true) {
      Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
    }

    if ($('.block__recommended-products').length > 0) {
      var $productPage = $('.block__recommended-products').parents('.product-page');
      Shopify.theme.jsRecommendedProducts.init($productPage);
    }

  });

  $(document)
  .on('shopify:section:deselect', function(e){

    // Shopify section as jQuery object
    var $section = $(e.target);

    // Vanilla js selection of Shopify section
    var section = document.getElementById('shopify-section-' + e.detail.sectionId);

    // Force hide state when section is selected in theme editor
    for (var i = 0; i < section.classList.length; i++) {
      if (section.classList[i].substring(0, 2) === "js") {
        var triggerClass = section.classList[i];
        if (Shopify.theme[triggerClass].showThemeEditorState) {
          Shopify.theme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
        }
      }
    }

  });

  // Block Shopify Shopify.theme editor events

  $(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    var $block = $('#shopify-section-' + blockId);

    if($('.jsFeaturedPromos').length > 0) {
      Shopify.theme.jsFeaturedPromos.blockSelect($parentSection, blockId);
    }

    if($('.jsSlideshowWithText').length > 0) {
      Shopify.theme.jsSlideshowWithText.blockSelect($parentSection, blockId);
    }

    if($('.jsSlideshowWithTextAnnouncementBar').length > 0) {
        Shopify.theme.jsSlideshowWithTextAnnouncementBar.blockSelect($parentSection, blockId);
      }

    if ($('.jsSlideshowClassic').length > 0) {
      Shopify.theme.jsSlideshowClassic.blockSelect($parentSection, blockId);
    }

    if($('.jsTestimonials').length > 0) {
      Shopify.theme.jsTestimonials.blockSelect($parentSection, blockId);
    }

    // Sidebar collection multi-tag filter
    if ($block.hasClass('sidebar__block')) {
      var $toggleBtn = $block.find('[data-sidebar-block__toggle="closed"]');
      if ($toggleBtn) {
        Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
      }
    }

    // Predictive search
    if (Shopify.theme_settings.enable_autocomplete == true) {
      Shopify.theme.predictiveSearch.init();
    }

    // Scrolling animations
    Shopify.theme.animation.init();

    // Object Fit Images
    Shopify.theme.objectFitImages.init();

  });

  $(document)
  .on('shopify:block:deselect', function(e){

    var $block = $('#shopify-section-' + e.detail.blockId);

    if ($block.hasClass('sidebar__block')) {
      var $toggleBtn = $block.find('[data-sidebar-block__toggle="open"]');
      if ($toggleBtn) {
        Shopify.theme.jsSidebar.closeSidebarBlock($toggleBtn);
      }
    }

  });

  $(document)
  .on('shopify:block:load', function(e){



  });
}

var jsSections;
// Document ready
$(function() {
  var jsSections = document.querySelectorAll('.shopify-section[class*=js]');
  
  jsSections.forEach(function(section) {
    for(var i = 0; i < section.classList.length; i++) {
      if(Shopify.theme[section.classList[i]]) {
        setTimeout(Shopify.theme[section.classList[i]].init.bind(Shopify.theme[section.classList[i]]), 0, $(section));
      }
    }
  })

  var resizeTimer;

  // Store window width in variable
  var width = $(window).width(), height = $(window).height();

  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

      Shopify.theme.objectFitImages.calculateAspectRatio();

      // Only run if window has actually been re-sized
      if($(window).width() != width || $(window).height() != height){
        Shopify.theme.jsProduct.disableSlideshow(null, $('.product-gallery__main:not([data-quickshop-gallery]), .product-gallery__thumbnails:not(.js-gallery-carousel)'));
        Shopify.theme.jsProduct.enableSlideshow($('.product-gallery__main:not([data-quickshop-gallery]), .product-gallery__thumbnails:not(.js-gallery-carousel)'));
      }

      if (!isScreenSizeLarge()){

        // When 798 or less
        Shopify.theme.jsHeader.unload();
        Shopify.theme.mobileMenu.init();
        $('.search-overlay__close').on('click', function(){
          Shopify.theme.jsHeader.hideSearch();
        });
        $('[data-show-search-trigger]').on('click', function(e){
          Shopify.theme.jsHeader.showSearch();
        });

      } else {

        // When larger than 798
        Shopify.theme.jsHeader.unload();
        Shopify.theme.mobileMenu.unload();
        Shopify.theme.jsHeader.init($('.jsHeader'));

        // Swatches
        if(Shopify.theme_settings.product_form_style == 'swatches') {
          Shopify.theme.thumbnail.enableSwatches();
        }
      }

    }, 250);

  });

  //Enable plyr
  Shopify.theme.video.init();

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  Shopify.theme.disclosure.enable();

  // Scrolling animations
  Shopify.theme.animation.init();

  // QuantityBox
  Shopify.theme.quantityBox.init();

  /* Show secondary image on hover */
  if (Shopify.theme_settings.show_secondary_image == true) {
    Shopify.theme.thumbnail.showVariantImage();
  }

  // Collection swatches
  if (Shopify.theme_settings.show_collection_swatches) {
    Shopify.theme.thumbnail.enableSwatches();
  }

  // Currency converter
  if (Currency.show_multiple_currencies || Currency.native_multi_currency) {
    Shopify.theme.currencyConverter.init();
  }

  //Infinite scrolling
  if ($('[data-custom-pagination]').length) {
    Shopify.theme.infiniteScroll.init();
  }

  //Select event for native multi currency checkout
  $('.shopify-currency-form select').on('change', function () {
    $(this)
      .parents('form')
      .submit();
  });

  // Tabs
  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  // Additional checkout buttons
  if (!isScreenSizeLarge()) {
    $('.additional-checkout-buttons').addClass('additional-checkout-buttons--vertical');
  }

  // Accordion
  if($('.accordion, [data-cc-accordion]').length > 0) {
    Shopify.contentCreator.accordion.init();
  }

  // Backwards compatiblity for Flexslider
  if($('.slider, .flexslider').length > 0) {
    Shopify.contentCreator.slideshow.init();
  }

  // Newsletter AJAX Form
  if ($('.newsletter-form__wrapper .contact-form').length > 0) {
    Shopify.theme.newsletterAjaxForm.init();
  }

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();

  // Flickity IOS Fix
  Shopify.theme.flickityIosFix();

 //Add class for top bar my-account
  Shopify.theme.jsTopBar.init();

  $('.back-to-top').on('click', function() {
    $('html, body').animate({scrollTop : 0},500);
    $('.skip-main').focus();
		return false;
  });
  
  $('.blog-filter').on('click', function() {
    $('.blog-wrapper').slideToggle(400);
  });

  $('.blog-category-filter .plp_sidebar_title').on('click', function() {
    $(this).toggleClass('active');
    $(this).parent().next().slideToggle(400);
  });

  $(".banner_shop_button").on('click', function(event) {

     // Make sure this.hash has a value before overriding default behavior
    if ($("#shop_character")) {
       // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = "#shop_character";

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });

  $(".banner_goodies_button").on('click', function(event) {
     // Make sure this.hash has a value before overriding default behavior
    if ($("#goodies_title")) {
       // Prevent default anchor click behavior
      event.preventDefault();
       // Store hash
      var hash = "#goodies_title";
      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
     } // End if
  });

  $(".banner_goodies_button_mobile").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if ($("#goodies_title_mobile")) {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = "#goodies_title_mobile";

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });

  $(".banner_events_button").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if ($("#events")) {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = "#events";

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
    
  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/
  //Used for cart functionality
  function htmlEncode(value){
      if (value) {
          return $('<div/>').text(value).html();
      } else {
          return '';
      }
  }

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function ajaxUpdateCart(lineID, quantity, parent) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function (data) {

        refreshCart(data);

        var lineIDIndex = lineID - 1;

        //check to see if there are correct amount of products in array
        if (typeof data.items[lineIDIndex] === "undefined"){
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
        }

        if(quantity > 0 && quantity != updated_quantity) {
          if (updated_quantity == 1) {
            items_left_text = "item left";
          } else {
            items_left_text = "items left";
          }

          $('.warning--quantity').remove();

          var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
          parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
          parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
        } else if (parent.is('#cart_form')) {
          $("#cart_form").submit();
        }
        Shopify.theme.jsAjaxCart.updateView();
      }
    });
  }
  
  

  function refreshCart(cart) {

    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart = $(".cart_content form");
    var discounted_price_total = 0;
    var total_savings = 0;

    // dk script
    var dk_count = 0;
    for(var i = 0; i < cart.items.length; i++) {
      if(cart.items[i].vendor === "DailyKarma") {
        dk_count+=1;
      }else {
        dk_count+=cart.items[i].quantity;
      }
    }
    // dk script end

    $cartBtn.text(value.replace(/[0-9]+/,dk_count)); // cart.item_count

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.js-cart_content__form').addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $('.js-cart_content__form').removeClass('hidden');

      $.each(cart.items, function(index, item) {
        var line_id = index + 1;
        cart_items_html += '<div class="ajax-cart__product media cart_item clearfix">' +
          '<figure class="ajax-cart__product-image media-left"><a href="javascript:;">';
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
              '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
            '</div>';
        }
        cart_items_html += '</a></figure>';

        cart_items_html += '<div class="ajax-cart__product-content media-content"><div class="ajax-cart__product-title cart_item__title"><div class="item_title"><a href="javascript:;">' + item.title;


        if(item.properties) {
          $.each(item.properties, function(title, value) {
            if (value) {
              cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
            }
          });
        }
        cart_items_html += '</a></div>';

        cart_items_html += '</div>';

        cart_items_html += '<div class="ajax-cart__price price"><strong class="right price">';

        

        cart_items_html += '<span class="money">' + Shopify.formatMoney(item.product_type == 'roundup-donation' ? item.final_line_price : item.final_price, $('body').data('money-format')) + '</span></strong>' + '</div></div>';
             cart_items_html += '<div class="ajax-cart__right-content media-right">'+
            '<a class="ajax-cart__delete delete_btn" data-item="' + item.id + '" data-line-id="' + line_id +'" href="#" title="Remove">'+
              '<button class="close" aria-label="close">'+
                '<span class="icon " data-icon="x"><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 14 14" version="1.1"><g id="style.guide.v2" stroke="none" stroke-width="1"><g id="srio.style-guide-color.v2" transform="translate(-845.000000, -3332.000000)" fill="#2D2A26" stroke="#000000"><g id="icon/x" transform="translate(841.899495, 3328.899495)"><g id="icon/account-copy-23" transform="translate(10.000000, 10.000000) rotate(-315.000000) translate(-10.000000, -10.000000) translate(3.000000, 3.000000)"><g id="icon/close" transform="translate(-0.000000, 0.000000)" stroke-width="2"><path d="M7,0 C7.38659932,2.36723813e-17 7.7,0.313400675 7.7,0.7 L7.699,6.3 L13.3,6.3 C13.6865993,6.3 14,6.61340068 14,7 C14,7.38659932 13.6865993,7.7 13.3,7.7 L7.699,7.699 L7.7,13.3 C7.7,13.6865993 7.38659932,14 7,14 C6.61340068,14 6.3,13.6865993 6.3,13.3 L6.299,7.699 L0.7,7.7 C0.313400675,7.7 -4.73447626e-17,7.38659932 0,7 C4.73447626e-17,6.61340068 0.313400675,6.3 0.7,6.3 L6.299,6.299 L6.3,0.7 C6.3,0.313400675 6.61340068,-2.36723813e-17 7,0 Z" id="Combined-Shape"></path></g></g></g></g></g></svg></span>'+
                '</button>'+
            '</a>'+
          '</div></div>';

      });

      cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' +
          '<span>Subtotal</span>';

      if(total_savings > 0 ) {
        cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' +
            '<span>Total Savings</span>';
      } else {
        cart_savings_html = "";
      }
    }

    

    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);

    if (typeof THRESHOLD_MET !== 'undefined' && THRESHOLD_MET) {
      $('body #free-gift-price').text('Free!');
    }

    
  }


    $('body').on("click", ".delete_btn", function() {

        event.preventDefault();

        $this = $(this);
        var cart_order_id = $(this).data('item');
        $('#updates_'+cart_order_id).val(0);

        $this.closest('.cart_item').addClass('animated fadeOutUp');

        ajaxUpdateCart($(this).data('line-id'), 0, $(this).parents('.cart_content'));

     });


     $('body').on("click", ".deletee_btn", function() {
             event.preventDefault();

             $this = $(this);
             var cart_order_id = $(this).data('item');
             $('#updates_'+cart_order_id).val(0);

             $this.closest('.cart_item').addClass('animated fadeOutUp');

             ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));

          });

  $('body').on("change", "#cart_form input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
  });

  $('body').on("change", ".cart_content input.quantity", function() {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
  });

  $('body').on("change", ".free-gift-checkbox", function() {
    $('body').addClass('loading');
    var $input = $(this);
    var variantId = $input.data('variantId');

    if(variantId)
    {
      $.ajax({
        url: '/cart/add.js',
        data:{
          items: [{
            quantity: 1,
            id: variantId
          }]
        } ,
        dataType: 'json',
        type: 'post',
        success: function() {
          if(typeof Shopify.theme.jsCart != 'undefined') {
            Shopify.theme.jsCart.updateView({item_count:1});
            Shopify.theme.jsCart.cartFreeGifts(variantId, false);
          }else {
            $('body').removeClass('loading');
          }

          Shopify.theme.jsAjaxCart.updateView();
          //Disable gift card quantity
          $('.quantity-plus, .quantity-minus, .quantity-input', '.gift-product').attr('disabled', true);
        },
        error: function(){
          $('body').removeClass('loading');
        }
      });
    }
  });

});


/*============================================================================
Slideshow arrows
==============================================================================*/


if(Shopify.theme_settings.icon_style == 'icon_solid') {
  var arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';
} else {
  var arrowShape = 'M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z';
}

$(window).on('load', function(){
  $('#ndnapp-contactform .form-control-select').on('change', function() {
    if($(this).val() == 'other') {
      $('.ndn-inner-scroll .form-group:nth-child(2)').show();
    } else {
      $('.ndn-inner-scroll .form-group:nth-child(2)').hide();
    }
  });
});